<template>
  <div class="setting-tag">
    <a-card :bordered="false" title="教材标签管理">
      <div class="toolbar">
        <a-input-search
          v-model="searchName"
          allow-clear
          placeholder="按标签名称搜索"
          style="width: 260px"
          @search="fetchList"
        />
        <CommonPermissions :p="$permissions.TEXTBOOK.CREATE">
          <a-button type="primary" icon="plus" @click="openCreate">新建标签</a-button>
        </CommonPermissions>
      </div>

      <a-table
        row-key="id"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
      >
        <template slot="action" slot-scope="_, record">
          <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
            <a @click="openEdit(record)">编辑</a>
          </CommonPermissions>
          <CommonPermissions :p="$permissions.TEXTBOOK.DELETE">
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除该标签？" @confirm="handleDelete(record)">
              <a class="danger">删除</a>
            </a-popconfirm>
          </CommonPermissions>
        </template>
      </a-table>
    </a-card>

    <a-modal
      :title="modalMode === 'create' ? '新建标签' : '编辑标签'"
      :visible="modalVisible"
      :confirm-loading="modalSubmitting"
      destroy-on-close
      width="480px"
      @ok="handleModalOk"
      @cancel="closeModal"
    >
      <a-form-model ref="formRef" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="标签名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入标签名称" :max-length="64" allow-clear />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import CommonPermissions from '@/components/CommonPermissions'
import TextBookApi from '@/api/src/textbook/api/TextBookApi'

const textBookApi = new TextBookApi()

export default {
  name: 'SettingTextbookTag',
  components: { CommonPermissions },
  data() {
    return {
      loading: false,
      list: [],
      searchName: '',
      columns: [
        { title: '标签名称', dataIndex: 'name', ellipsis: true },
        {
          title: '使用次数',
          dataIndex: 'useCount',
          customRender: (t) => (t != null ? t : '—'),
        },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: 140 },
      ],
      modalVisible: false,
      modalSubmitting: false,
      modalMode: 'create',
      editingId: null,
      form: {
        name: '',
      },
      rules: {
        name: [{ required: true, message: '请输入标签名称', trigger: 'blur' }],
      },
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const name = (this.searchName || '').trim() || undefined
        const res = await textBookApi.findTextbookTagList(name ? { name } : {})
        const raw = Array.isArray(res) ? res : []
        this.list = raw.slice().sort((a, b) => {
          const na = (a && a.name) || ''
          const nb = (b && b.name) || ''
          return na.localeCompare(nb, 'zh-CN')
        })
      } catch (e) {
        console.error(e)
        this.$message.error(e.message || '获取标签列表失败')
        this.list = []
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.modalMode = 'create'
      this.editingId = null
      this.form = { name: '' }
      this.modalVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    openEdit(record) {
      this.modalMode = 'edit'
      this.editingId = record.id
      this.form = {
        name: record.name || '',
      }
      this.modalVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    closeModal() {
      this.modalVisible = false
    },
    handleModalOk() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        const name = (this.form.name || '').trim()
        if (!name) {
          this.$message.warning('请输入标签名称')
          return
        }
        this.modalSubmitting = true
        try {
          if (this.modalMode === 'create') {
            await textBookApi.addTextbookTag({ name })
            this.$message.success('创建成功')
          } else {
            await textBookApi.updateTextbookTag(this.editingId, { name })
            this.$message.success('保存成功')
          }
          this.modalVisible = false
          await this.fetchList()
        } catch (e) {
          console.error(e)
          this.$message.error(e.message || '操作失败')
        } finally {
          this.modalSubmitting = false
        }
      })
    },
    async handleDelete(record) {
      try {
        await textBookApi.deleteTextbookTag(record.id)
        this.$message.success('已删除')
        await this.fetchList()
      } catch (e) {
        console.error(e)
        this.$message.error(e.message || '删除失败')
      }
    },
  },
}
</script>

<style scoped lang="less">
.setting-tag {
  padding: 0;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.danger {
  color: #ff4d4f;
}
</style>
